var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{selected:_vm.isSelected,view:true},style:({
  width:_vm.viewWidth +'px',
  height: _vm.viewHeight+'px',
  backgroundColor:_vm.viewBackgroundColor,
  backgroundImage:'url('+_vm.viewBackgroundImage+')'
}),attrs:{"id":"view"},on:{"mousedown":function($event){$event.preventDefault();if($event.target !== $event.currentTarget){ return null; }return _vm.onViewSelected($event)}}},_vm._l((_vm.parts),function(part){return _c(part.type,{tag:"div",attrs:{"p-id":part.id,"p-type":part.type,"name":part.name}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-388e1a6d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/content-middle-view.vue
// module id = null
// module chunks = 